import React from 'react';
import { Settings } from '../components';

const SettingsLayout = () => {
  return (
    <>
      <Settings />
    </>
  );
};

export default SettingsLayout;
